// internationalization
import { useTranslation } from 'react-i18next';

// material ui
import { Box, Paper, Stack, Typography } from '@mui/material';

// components
import { formatNumber } from '@/utils/formatters';

// relative
import type { BenchmarkKpiCardsProps } from './benchmark';

const BenchmarkKpiCards = ({ benchmarkData }: BenchmarkKpiCardsProps) => {
  const { t } = useTranslation('portfolio-analysis');

  return (
    <Stack direction="row" spacing={2}>
      <Box sx={{ flex: 1 }}>
        <Paper
          variant="outlined"
          sx={{
            p: 2,
            borderRadius: 2,
            height: '100%',
            backgroundColor: (theme) => theme.palette.action.hover,
          }}
        >
          <Stack spacing={0.5}>
            <Typography variant="caption" color="text.secondary">
              {t('benchmarkChart.kpi.yourBuilding')}
            </Typography>
            <Typography variant="h6">
              {formatNumber(benchmarkData.kWhPrYPrM2)}{' '}
              {t('benchmarkChart.unit')}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {t('benchmarkChart.kpi.consumptionLabel')}
            </Typography>
          </Stack>
        </Paper>
      </Box>
      <Box sx={{ flex: 1 }}>
        <Paper
          variant="outlined"
          sx={{ p: 2, borderRadius: 2, height: '100%' }}
        >
          <Stack spacing={0.5}>
            <Typography variant="caption" color="text.secondary">
              {t('benchmarkChart.kpi.typicalBuilding')}
            </Typography>
            <Typography variant="h6">
              {formatNumber(benchmarkData.GroupMedian ?? 0)}{' '}
              {t('benchmarkChart.unit')}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {t('benchmarkChart.kpi.groupMedianLabel')}
            </Typography>
          </Stack>
        </Paper>
      </Box>
    </Stack>
  );
};

export default BenchmarkKpiCards;
